export default function getValuesForKeys(obj, keyPart){
    const values = [];
    for (const key in obj) {
        if (key.startsWith(keyPart)) {
            values.push(obj[key]);
        }
    }
    return values;
}